import { render, staticRenderFns } from "./ThumbnailDropzone2.vue?vue&type=template&id=4243ee35&scoped=true&"
import script from "./ThumbnailDropzone2.vue?vue&type=script&lang=js&"
export * from "./ThumbnailDropzone2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243ee35",
  null
  
)

export default component.exports